import React, { Fragment, useContext, useEffect } from "react";
import { AppInputDropDown, LineText, ParagraphText, UBAppModal, UBInput } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import StockDropDownInput from "../../VariantComponents/StockDropDownInput";
import { Box } from "@material-ui/core";
import { WEIGHT_TYPES, PARCEL_TYPES, DIMENSIONS } from "../../../../constants";
import styles from "./styles.module.css";


const OrderShipModal = ({ headerTitle, body, footer }) => {
    const [I18n] = useContext(LanguageContext);

    const {
        toggleShipModal: handleClose,
        onChangeText,
        shipParcel,
        toggle,
        title,
    } = body || {};

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (toggle) {
                if (event.key === 'Escape') {
                    // Close the modal when the 'Escape' key is pressed
                    handleClose()
                } else if (event.key === 'Enter') {
                    // footer?.length && !footer[0].disabled && footer[0]?.action(); // Trigger an action when the 'Enter' key is pressed
                }
            }
        };

        // Add the event listener when the modal is open
        if (toggle) {
            window.addEventListener('keydown', handleKeyDown);
        }

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [toggle, footer]);
    const dimension = shipParcel?.dimensions.length ? `${shipParcel?.dimensions.length} x ${shipParcel?.dimensions.width} x ${shipParcel?.dimensions.height}` : ''
    return (
        <UBAppModal
            id="order_ship_modal"
            handleClose={handleClose}
            className={styles.orderShipModal}
            open={toggle}
            header={{
                title: (
                    <ParagraphText className="d-flex align-items-center fontSize20 fontWeight500 newFontColor">
                        {headerTitle}
                    </ParagraphText>
                ),
                handleClose: handleClose,
                dont_show_cross_icon: true,
            }}
            footer={footer}

        >
            <div className="orderShipModalBody">
                <AppInputDropDown
                    data={{
                        list: Object.keys(PARCEL_TYPES),
                        value: shipParcel?.parcel_type,
                        onChangeText,
                        title,
                    }}
                    RenderInput={(params = {}) => (
                        <StockDropDownInput
                            params={params}
                            //   label={I18n.category}
                            //   required
                            placeholder={title}
                        />
                    )}
                />
                {shipParcel.parcel_type &&
                    <Fragment>
                        <Box className="d-flex w-100" gridGap={8} alignItems={"center"}>
                            <UBInput inputId="order_ship_weight" label={I18n.enter_weight} baseClassname="shipWeightInput" style={{ height: '42px', flex: 1 }} type='number' acceptDec value={shipParcel?.weight?.value} onChange={(name, value) => { onChangeText(I18n.enter_weight, value) }} />
                            <AppInputDropDown
                                data={{
                                    list: Object.keys(WEIGHT_TYPES),
                                    value: shipParcel?.weight?.unit,
                                    id: "category",
                                    onChangeText,
                                }}
                                RenderInput={(params = {}) => (
                                    <StockDropDownInput
                                        params={params}
                                        placeholder={I18n.unit}
                                    />
                                )}
                                className={"p-0 m-0 weightDropdownStyle"}
                            />
                        </Box>
                    </Fragment>
                }
                {shipParcel.parcel_type === 'Carton' && <Fragment>
                    <Box className="d-flex w-100" gridGap={8} mt={2}>
                        <AppInputDropDown
                            data={{
                                list: Object.keys(DIMENSIONS),
                                value: dimension,
                                id: "category",
                                onChangeText: (_, select) => onChangeText(I18n.select_dimensions, select),
                                title: <ParagraphText>{I18n.select_dimensions} <span className="newLightColor">({I18n.length_width_height})</span></ParagraphText>,
                            }}
                            RenderInput={(params = {}) => (
                                <StockDropDownInput
                                    params={params}
                                    placeholder={I18n.select_dimensions}
                                />
                            )}
                            className={"p-0 m-0 dimensionDropdownStyle"}
                        />
                    </Box>
                </Fragment>}
            </div>
        </UBAppModal>
    );
};

export default OrderShipModal;
